import { Button, Form, Input } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { api, endpoint } from "@/api";
import { userRole } from "@/constant";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";
import { flare } from "@flareapp/js";

const onFinishFailed = (errorInfo) => {
  // eslint-disable-next-line no-console
  console.log("Failed:", errorInfo);
};

function MetaCustomReportModal({ show, setShow, mode = "create", data = {}, setData, getData }) {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
  const [searchParams] = useSearchParams();

  const { name } = data;

  const [selectedBusiness, setSelectedBusiness] = useState();

  // fetch
  const getBusiness = async () => {
    try {
      const data = await api.get(endpoint.business);

      if ((Array.isArray(data?.data) && data.data.length === 1) || userDetails.role !== userRole.superAdmin) {
        setSelectedBusiness(data.data[0]._id);
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("business list", error);
    }
  };

  useEffect(() => {
    getBusiness();
    form.setFieldsValue({ name });
  }, [mode]);

  const handleClose = () => {
    if (mode === "create") {
      navigate("/report-list");
    }
    setShow(false);
    form.setFieldsValue({});
  };

  // Report operation
  const deleteHandler = () => {
    try {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you wish to delete this report?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await axios.delete(`${endpoint.remove_customReport}/${data._id}`, {
            withCredentials: true,
          });
          if (response.status === 200) {
            Swal.fire("Deleted!", "Report  has been deleted.", "success");
            navigate("/report-list");
          }
        }
      });
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log(error);
    }
  };

  // update Report
  const updateReport = async (body) => {
    try {
      const response = await api.put(endpoint.update_customReport + "/" + data?._id, body);
      if (response?.success) {
        Swal.fire("", "Update Report Successfully!", "success");
        setShow(false);
        getData();
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  // generate Report
  const generateReport = async (body) => {
    try {
      const response = await api.post(endpoint.create_customReport, {
        ...body,
        mode: searchParams.get("cp") === "true" ? "Duplicated" : "Generated",
      });
      if (response.success) {
        Swal.fire("", "Report Generated Successfully!", "success");
        navigate("/report-list");
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  const onFinish = async (values) => {
    const reportType = uuid();
    const body = {
      ...values,
      reportType,
    };
    // console.log({ mode });

    if (mode === "copy") {
      setData((pre) => ({ ...pre, ...values }));
      setShow(false);
    } else if (mode === "create") {
      body.user = userDetails._id;
      body.business = selectedBusiness;
      generateReport(body);
    } else {
      updateReport(body);
    }
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered size="lg" backdropClassName="modal-bg-1">
        {/* header */}
        <Modal.Header closeButton className="bg-gray-200 border-dark-subtle">
          <Modal.Title>{mode === "create" ? "Add Report " : "Edit Report "}</Modal.Title>
        </Modal.Header>
        {/* body */}
        <Modal.Body className="p-3">
          <Form
            name="createDashboard"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
          >
            <Row lg={2}>
              <Col>
                <Form.Item label="Name" name="name" rules={[{ required: true, message: "Input Report  Name" }]}>
                  <Input placeholder="Enter Report  Name" />
                </Form.Item>
              </Col>
            </Row>

            <div className="d-flex align-items-center justify-content-end gap-3">
              <Button type="primary" htmlType="submit">
                {mode === "create" ? "Create Report " : "Update Report "}
              </Button>
              {mode === "edit" && data._id && (
                <Button type="default" onClick={deleteHandler} danger htmlType="button">
                  Delete Report
                </Button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default MetaCustomReportModal;

MetaCustomReportModal.propTypes = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  mode: PropTypes.string,
  data: PropTypes.object,
  setData: PropTypes.func,
  getData: PropTypes.func,
};
